<template>
  <form-item-facade
    class="input-item"
    :name="name"
    :errors="errors"
    :rules="rules"
  >
    <input-facade
      v-model="model"
      :disabled="disabled"
      :name="name"
      :placeholder="placeholder"
    >
      <template #suffix>
        <slot name="suffix"></slot>
      </template>
    </input-facade>
  </form-item-facade>
</template>

<script setup>
  import { defineModel } from 'vue';
  import FormItemFacade from "@/lib/ant-design-vue/components/FormItemFacade.vue";
  import InputFacade from '@/lib/ant-design-vue/components/InputFacade.vue';

  const model = defineModel();

  defineProps({
    // HTML-поле "name" для элемента формы.
    name: {
      type: [Array, String],
      required: true,
    },

    // Whether the input is disabled
    disabled: {
      type: Boolean,
      default: false,
    },

    // Объект, обрабатывающий ошибки.
    errors: Object,

    // Текст подсказки, что нужно ввести в поле
    placeholder: {
      type: String,
      default: '',
    },

    // Правила валидации поля.
    rules: Object,
  });
</script>

<style lang="scss" scoped>

</style>